// @flow
import React, {Fragment, PureComponent, type ComponentType} from 'react';
import ReactResizeDetector from 'react-resize-detector';
import Experiment, {On, Off} from '@homeaway/react-experiment';
import TravelerBannerContainer from '../TravelerBannerContainer/TravelerBannerContainer';
import AppDownloadBanner from '../AppDownloadBanner/AppDownloadBanner';
import GlobalBannerContainer from '../GlobalBannerContainer/GlobalBannerContainer';
import GDPRBanner from '../GDPRBanner/GDPRBanner';
import type {Size} from '../../actions/topBanners';
import type {State as AbacusState} from '../../reducers/abacus';
import type {SystemData} from '../../../server/utils/systemData';
import type {SearchRequestQueryResponseData} from '../../queries/searchRequestQuery';

import './withTopBanners.less';
import {
    HA_NATIVE_ADOPTION_BANNER_SEARCH_UI,
    VRBO_WEB_GLOBAL_MESSAGING_BANNER
} from '../../abacus/experiments';

export type Props = {
    onTopBannersSizeChanged: (Size) => any,
    abacus: AbacusState,
    siteName: string,
    fullLocale: string,
    system: SystemData,
    onResize: Function,
    data: SearchRequestQueryResponseData
};

export default function withTopBanners<OwnProps: {}>(
    WrappedComponent: ComponentType<$Supertype<OwnProps>>
): ComponentType<Props> {
    return class TopBanners extends PureComponent<Props> {
        getGDPRBannerVersion = () => {
            const {
                abacus: {ha_gdpr_banner: experiment}
            } = this.props;

            if (
                experiment &&
                experiment.bucket &&
                experiment.bucket.bucketConfig
            ) {
                const {
                    bucket: {bucketConfig}
                } = experiment;

                return bucketConfig;
            }

            return null;
        };

        onResize = (width, height) => {
            this.props.onTopBannersSizeChanged({
                height
            });
        };

        render() {
            const {fullLocale, data} = this.props;
            const {results} = data || {};
            const {globalMessages} = results || {};
            const gdprBannerVersion = this.getGDPRBannerVersion();
            return (
                <Fragment>
                    <div className="TopBanners">
                        {gdprBannerVersion && (
                            <GDPRBanner
                                fullLocale={fullLocale}
                                bannerVersion={gdprBannerVersion}
                            />
                        )}
                        <Experiment name={VRBO_WEB_GLOBAL_MESSAGING_BANNER}>
                            <On>
                                <GlobalBannerContainer
                                    globalMessages={globalMessages}
                                />
                            </On>
                            <Off>
                                <TravelerBannerContainer />
                            </Off>
                        </Experiment>
                        <Experiment
                            name={HA_NATIVE_ADOPTION_BANNER_SEARCH_UI}
                            variant={Experiment.ON}
                        >
                            <AppDownloadBanner />
                        </Experiment>
                        <ReactResizeDetector
                            handleHeight
                            onResize={this.onResize}
                        />
                    </div>
                    <WrappedComponent {...this.props} />
                </Fragment>
            );
        }
    };
}
